import "./media.scss";
import MediaPagination from "../../components/media-pagination";
import HeadlineSection from "../../components/headline-section";
import MediaCard from "../../components/media-card";
import media1 from "../../assets/home/media1.jpg";
import media2 from "../../assets/home/media2.jpg";
import media3 from "../../assets/home/media3.jpg";
import media4 from "../../assets/home/media4.jpg";

const Media = () => {
  return (
    <>

    <div  className="media-page">
         <div>
            <HeadlineSection headline="المركز" secondHeadline="الإعلامي" />
            <p className="description-title">حديث الصورة... إنجاز بإيجاز</p>
          </div>
        
        <div className="all-media">

            <MediaCard mediaImage={media1}
            mediaTitle={"تقرير عام 1440"}/>
            <MediaCard mediaImage={media2}
            mediaTitle={"تقرير عام 1441"}/>
            <MediaCard mediaImage={media3}
            mediaTitle={"تقرير عام 1436"}/>
            <MediaCard mediaImage={media4}
            mediaTitle={"تقرير عام 1435"}/>
            
        </div>
        <div className="all-media">

          <MediaCard mediaImage={media1}
          mediaTitle={"تقرير عام 1440"}/>
          <MediaCard mediaImage={media2}
          mediaTitle={"تقرير عام 1441"}/>
          <MediaCard mediaImage={media3}
          mediaTitle={"تقرير عام 1436"}/>
          <MediaCard mediaImage={media4}
          mediaTitle={"تقرير عام 1435"}/>
        
     </div>

        <div className="my-pagination">
              <MediaPagination/>
          </div>
    </div>
      
    </>
  );
};

export default Media;
